import styled from 'styled-components'

interface AlertCircleProps {
    hasAlert: boolean
}

export const UserProfile = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    > span:nth-child(2) {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        color: #243f5c;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        display: none;
        @media (min-width: 500px) {
            display: unset;
        }
    }

    > svg {
        transform: rotate(90deg);
    }
`

export const PopoverMenu = styled.div`
    background: #fff;
    border-radius: 6px;
    position: absolute;
    z-index: 9;
    right: 10px;
    top: calc(40px + 10px);
    padding: 10px 0 0 0;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    display: flex;
    flex-direction: column;
    min-width: 180px;
    max-width: 220px;

    .profile {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        margin-bottom: 10px;

        > span {
            width: 40px;
            height: 40px;
        }
        > h1 {
            font-size: 16px;
            font-family: 'Inter', sans-serif;
            font-weight: 500;
            padding: 0 5px;
            max-width: 190px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        > a {
            font-weight: 500;
            font-size: 14px;

            color: #4c83ee;
            &:hover {
                color: #566583;
            }
        }
    }

    .msg-notify {
        @media (min-width: 500px) {
            display: none;
        }
    }

    > button.email {
        position: relative;
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 10px 25px;
        cursor: pointer;
        background: rgba(0, 157, 221, 0.02);

        &::before {
            content: '';
            position: absolute;
            width: 4px;
            height: 100%;
            background-color: #009ddd;
            border-radius: 6px;
            left: 0;
        }

        > span {
            font-family: 'Inter';
            font-weight: 500;
            max-width: 190px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .link {
        padding: 10px 25px;
        font-weight: 500;
        font-size: 14px;
        color: #566583;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
            'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
            'Helvetica Neue', sans-serif;

        display: flex;
        align-items: center;
        gap: 6px;
        &:hover {
            cursor: pointer;
            background: rgba(0, 157, 221, 0.1);
        }
    }

    .form-button {
        color: #4c83ee;
    }
`

export const Avatar = styled.span`
    background: #333;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #fff;

    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
`

export const AlertCircle = styled.span<AlertCircleProps>`
    display: ${(props) => (props.hasAlert ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    background: #ff1d44;
    color: #fff;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-left: auto;
    padding-bottom: 2px;
`
